import { AlertDialog } from "native-base";

export default AlertDialog;